
import {
  Vue, Component, Prop, Ref,
} from 'vue-property-decorator';
import { requiredRules } from '@/features/common/helpers/validationRules';
import { VForm } from '@/features/common/types';
import { FedExValidateAddressRequest } from '../../types/fedexRegistration';

@Component
export default class FedExAddressStep extends Vue {
  @Ref('form') form!: VForm;

  @Prop({ default: false }) loading!: boolean;

  @Prop({ default: null }) initialData!: FedExValidateAddressRequest | null;

  private requiredRules = requiredRules;

  private formData: FedExValidateAddressRequest = {
    accountNumber: '',
    customerName: '',
    streetLines: ['', ''],
    city: '',
    stateOrProvinceCode: '',
    postalCode: '',
    payorCountryCode: '',
    residential: false,
  };

  created(): void {
    if (this.initialData) {
      this.formData = {
        ...this.initialData,
        streetLines: [
          this.initialData.streetLines[0] || '',
          this.initialData.streetLines[1] || '',
        ],
      };
    }
  }

  private onSubmit(): void {
    if (!this.form.validate()) return;

    const payload: FedExValidateAddressRequest = {
      ...this.formData,
      accountNumber: this.formData.accountNumber.trim(),
      customerName: this.formData.customerName.trim(),
      city: this.formData.city.trim(),
      stateOrProvinceCode: this.formData.stateOrProvinceCode.trim(),
      postalCode: this.formData.postalCode.trim(),
      streetLines: this.formData.streetLines
        .map((line) => line.trim())
        .filter((line) => line !== ''),
    };

    this.$emit('submit', payload);
  }
}
